mutation UpdateResizedTemplate($masterTemplateId: ID!, $parentId: ID!, $jobId: ID) {
    updateResizedMasterTemplate(masterTemplateId: $masterTemplateId, parentId: $parentId, jobId: $jobId) {
        jobId
    }
}
